import { Container } from '@material-ui/core';
import React from 'react';

const projectData = [
    {
        name: "yeender.com",
        title: "web aplication",
        link: "https://yeender.com",
        description: "Yeender is the best digital marketing agency in Toronto, Canada. We've SEOs, Graphic Designers, Web & App developers in our team to offer you a smooth experience with Yeender.",
        img: "https://i.imgur.com/TxY47KD.png",
        date: ""
    },
    {
        name: "ottawareno.net",
        title: "...",
        link: "-",
        description: "-------",
        img: "https://i.imgur.com/4kvHioa.jpg",
        date: ""
    },
    {
        name: "Zawiyah Foundation",
        title: "web aplication",
        link: "https://www.zawiyahfoundation.com",
        description: "Allah Almighty has made man the noblest of creatures and by placing the crown of His Khilafah on his head, has sent every individual to the world as a test for a certain period of time...",
        img: "https://i.imgur.com/b6Ie16o.png",
        date: ""
    },
    {
        name: "sahara",
        title: "web aplication",
        link: "https://sahara-frontend.vercel.app",
        description: "-------",
        img: "https://i.imgur.com/29YOO22.png",
        date: ""
    },
    {
        name: "I imagine",
        title: "web aplication",
        link: "https://iimagine.vercel.app",
        description: "I imagine is a web app development company, working together with businesses and individuals to deal with the complexity of web development & catered solutions with excellence.",
        img: "https://i.imgur.com/XW8NCZT.png",
        date: ""
    },
    {
        name: "Athena",
        title: "web design",
        link: "https://brave-almeida-0c3468.netlify.app",
        description: "✨🎄🎉🎊🎀 Athena web design ✨🎄🎆🎊🎀",
        img: "https://i.imgur.com/r6kCHOG.jpg",
        date: ""
    },
    {
        name: "Apperment-hunt",
        title: "Mern Stack Project",
        link: "https://apperment-hunt.web.app",
        description: "✨A homeowner can advertise his or her home. The user will be able to choose the house. And Also Users will be able to apply for rent. The user can see the list of his application. Home Wonner see..",
        img: "https://i.imgur.com/rGVRoYC.png",
        date: ""
    },
    {
        name: "travle-guru",
        title: "Mern Stack Project",
        link: "https://travle-guru-mahbub.firebaseapp.com",
        description: "🥇🏅🥉A single-page web app Used three methods of signing in. Where a user can select the desired destination and book a hotel there.🎇🧨🎈",
        img: "https://i.imgur.com/2OLsbDc.png",
        date: ""
    },
    {
        name: "hot-onion",
        title: "Mern Stack Project",
        link: "https://hot-onion-restaurent-seven.vercel.app/",
        description: "e-co || Food website",
        img: "https://i.imgur.com/pHuY6EG.png",
        date: ""
    },
    {
        name: "ottawareno.net",
        title: "...",
        link: "-",
        description: "-------",
        img: "https://i.imgur.com/4kvHioa.jpg",
        date: ""
    },
    {
        name: "ottawareno.net",
        title: "...",
        link: "-",
        description: "-------",
        img: "https://i.imgur.com/EdyZ933.jpg",
        date: ""
    },
    {
        name: "ottawareno.net",
        title: "...",
        link: "-",
        description: "-------",
        img: "https://i.imgur.com/mGt75eZ.jpg",
        date: ""
    },
]

const Portfolio = () => {
    const [abc, def] = React.useState();
    return (
        <div className="portfolio_area">
            <div className="portfolio_c_area_title">
                <h1>PORTFOLIO</h1>
                <h2>Discover My Latest Works</h2>
                <hr />
            </div>
            <Container>
                <div className="row row-cols-1 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 g-4 align-items-center justify-content-center">
                    {projectData.map((data, index) => (
                        <div key={index} className="col">
                            <div className="card">
                                <img src={data.img} alt="img" />
                                {/* hello */}
                                <div className="descriptions">
                                    <div className="text-center">
                                        <div className="card-header">{data.name}</div>
                                        <div className="card-body">
                                            <h5 className="card-title">{data.title}</h5>
                                            <p className="card-text">
                                                {data.description}
                                            </p>
                                            <a href={data.link === '-' ? (data.img) : (data.link)} target="_blank" rel="noopener noreferrer" className="btn btn-primary"><i className="fas fa-external-link-alt"></i> Live Website</a>
                                        </div>
                                        <div className="card-footer text-muted">{data.date}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <p>veiw more..</p>
            </Container>
        </div>
    );
};

export default Portfolio;